<form nz-form [formGroup]="observacoesForm" id="observacoesForm">
  <div class="row">
    <div class="col-sm-12">
      <nz-form-item>
        <nz-form-label [nzSm]="4" nzFor="textoObservacao" class="form-label">Observações</nz-form-label>
        <nz-form-control [nzSm]="20">
          <textarea nz-input rows="4" formControlName="textoObservacao"
           maxlength="5000" (input)="atualizarContador()"></textarea>
        </nz-form-control>


      </nz-form-item>
      <div class="contador-caracteres text-right">
        {{ contadorCaracteres }}/5000 caracteres
      </div>
    </div>
  </div>
</form>
